import { Expose } from "class-transformer";

export class CommentProjectResourceDto {
  @Expose()
  comment: string;
}
